import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { chatActions, chatSelectors, chatTypes } from 'redux/chat';
import useReduxLoading from 'hooks/useReduxLoading';

const useConversableMembers = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(chatActions.getConversableMembers());
  }, [dispatch]);

  const options = useSelector(chatSelectors.getConversableMemberIds);
  const loading = useReduxLoading(
    chatTypes.getConversableMembers,
    [chatTypes.getConversableMembersSuccess, chatTypes.getConversableMembersFailure],
    true,
  );

  return { options, loading };
};

export default useConversableMembers;
